function getTop(ref: React.RefObject<HTMLElement>, headerSize: number) {
  return (ref.current?.getBoundingClientRect().top ?? 0) + window.scrollY - headerSize;
}

export {getTop}